// export const passReg = /(?=.*[0-9])(?=.*[a-zA-Z]).{6,18}/
export const passReg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,18}$/
export const passStrLength = /^.{6,18}$/
export const passComplexReg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)/
// export const emojiReg = /^((\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f\ude80-\udeff])|[\u2600-\u2B55]),((\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f\ude80-\udeff])|[\u2600-\u2B55])$/
// export const specialStrReg = //
export const nameReg = /^[\u4e00-\u9fa5a-zA-Z0-9$,.! ?=+-，。！？]+$/
